var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-step c-step--final"},[_c('technoLogo'),_c('Head',{attrs:{"dataTitle":' ',"dataStrong":'Tak – din henvendelse er nu sendt til Techno Forsikring, som vil kontakte dig snarest'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }